import { useNavigate } from 'react-router-dom';

import { useUserBalanceStore } from '@/entities/balance';
import { useCognitoCheckUser, useCurrentUser } from '@/entities/user/currentUser';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { logout } from '@/shared/lib/logout';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';
import { Profile } from '@/shared/ui/Profile';

export type ProfileItemProps = {
  active?: boolean;
  variant?: 'filled' | 'outlined';
};

export const ProfileItem = ({ active = false, variant = 'filled' }: ProfileItemProps) => {
  const navigate = useNavigate();

  const { data } = useCognitoCheckUser();
  const picture = data?.picture;

  const { data: user } = useCurrentUser();

  const { planName: subscriptionPlanName } = useUserBalanceStore();

  const planName = IS_WHITE_LABEL ? 'Account' : subscriptionPlanName;

  const handleClick = () => {
    if (!IS_WHITE_LABEL) {
      navigate(`/${PATHS.account}`);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      showErrorAlert(error);
    }
  };

  return (
    <Profile
      active={active}
      cursor={IS_WHITE_LABEL ? 'default' : 'pointer'}
      email={user?.email}
      picture={picture}
      planName={planName}
      variant={variant}
      handleLogout={IS_WHITE_LABEL ? handleLogout : undefined}
      onClick={handleClick}
    />
  );
};
